"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferAssetGalleryFieldAssets = void 0;
var OfferAssetGalleryFieldAssets_1 = require("./OfferAssetGalleryFieldAssets");
Object.defineProperty(exports, "OfferAssetGalleryFieldAssets", { enumerable: true, get: function () { return OfferAssetGalleryFieldAssets_1.OfferAssetGalleryFieldAssets; } });
